// eslint-disable-next-line max-len, @stylistic/max-len
export const METADATA_PAGE_TITLE = 'New Cars For Sale In Singapore | Latest Prices - Sgcarmart';
export const METADATA_PAGE_DESCRIPTION = (
  // eslint-disable-next-line max-len, @stylistic/max-len
  'Looking for a new car? Explore and compare the latest prices, specs, and detailed information on new cars for sale in Singapore.'
);

export const METADATA_BRAND_PAGE_TITLE = (brand: string) => `Latest ${brand} Cars in Singapore | Price & Listings - Sgcarmart`;
export const METADATA_BRAND_PAGE_DESCRIPTION = (brand: string) => `Explore new ${brand} cars for sale in Singapore. Discover the latest pricing, specifications, and photos of new ${brand} models. Start your car-buying journey today.`;
export const SECTION_TITLE_NEW_CARS_LISTING_PAST_CARS = 'Past Cars';
